/* ============
 * City Module Mutations
 * ============
 */

import {
  TYPE_OF_VIEW,
  TYPE_OF_ORDER_VIEW,
} from './../../mutation-types';

export default {
  [TYPE_OF_VIEW](state, view) {
    state.view = view;
  },

  [TYPE_OF_ORDER_VIEW](state, orderViewType) {
    state.orderViewType = orderViewType;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/view/mutations.js